// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const saveCustomer = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("post","customers", data)
    let sendData = data;
    let returnData = res.data;
    commit('saveCustomer', {sendData, returnData});
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customer_get = async ({ commit }, data) => {
    commit('customerLoading', true);
    commit('customerStatusNull');
    let res;
    res = await sendReq("get","customers", data)
    commit('listCustomer', res.data);
    commit('customerLoading', false);
}

export const customer_list = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("get","customers", data)
    commit('listCustomer', res.data);
    commit('customerLoading', false);
}

export const customer_delete = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("delete","customers/"+data.id)
    commit('actionStatus', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const getCustomerDetail = async ({ commit }, data) => {
    commit('customerLoading', true);
    commit('customerStatusNull');
    let res;
    res = await sendReq("get","customers/"+data.id, data)
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeraddresses_get = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("get","customers/"+data.parent_id+"/addresses", data)
    commit('setCustomerAddress', res.data);
    commit('customerLoading', false);
}

export const customeraddresses_list = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    if(data[0]){
        res = await sendReq("get","customers/"+data[0]+"/addresses", data)
        commit('setCustomerAddress', res.data);
    }
    commit('customerLoading', false);
}

export const customerInfo_edit= async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("put","customers/"+data.id, data)
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeraddresses_add = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("post","customers/"+data.parent_id+"/addresses", data)
    commit('setCustomerAddress', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeraddresses_edit = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("put","customers/"+data.parent_id+"/addresses/"+data.id, data)
    res.data.data = null // Tüm liste gelmediği için yanlış oluyor o yüzden elle manipüle ediyorum
    commit('setCustomerAddress', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeraddresses_delete = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("delete","customers/"+data.parent_id+"/addresses/"+data.id, data)
    commit('setCustomerAddress', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeruser_get = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("get","customers/"+data.parent_id+"/contacts", data)
    commit('setCustomerContact', res.data);
    commit('customerLoading', false);
}

export const customeruser_add = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("post","customers/"+data.parent_id+"/contacts", data)
    commit('setCustomerContact', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeruser_edit = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("put","customers/"+data.parent_id+"/contacts/"+data.id, data)
    commit('setCustomerContact', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customeruser_delete = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("delete","customers/"+data.parent_id+"/contacts/"+data.id, data)
    commit('setCustomerContact', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customer_state = async ({commit}, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("put","customers/"+data.id+"/state", data)
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customersubscription_get = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("get","customers/"+data.parent_id+"/subscriptions", data)
    commit('setCustomerSubscriptions', res.data);
    commit('customerLoading', false);
}

export const customersubscription_add = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("post","customers/"+data.parent_id+"/subscriptions", data)
    commit('setCustomerSubInfo', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customersubscription_delete = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("delete","customers/"+data.parent_id+"/subscriptions/"+data.id, data)
    commit('setCustomerSubInfo', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const customersubscription_edit = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("put","customers/"+data.parent_id+"/subscriptions/"+data.id, data.customerSub[0])
    commit('setCustomerSubInfo', res.data);
    commit('customerLoading', false);
}

export const customer_is_approve = async ({commit}, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("put","customers/"+data.id+"/approval", data)
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}

export const getCustomerCompany = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("get","customers/"+data.id+"/companies", data)
    commit('setCustomerCompany', res.data);
    commit('customerLoading', false);
}

export const addCompanyCustomer = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("post","customers/"+data.customerId+"/companies", data)
    commit('setCustomerCompany', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}


export const customerApprovalHistory = async ({ commit }, id) => {
    commit('customerLoading', true)
    let res
    res = await sendReq("get", `customers/${id}/approval`)
    commit('setApprovalHistory', res.data)
    commit('customerLoading')
}

export const setCustomerCompany = async ({ commit }, data) => {
    commit('customerLoading', true);
    let res;
    res = await sendReq("post","customers/"+data.customerId+"/companies", data)
    commit('setCustomerCompany', res.data);
    commit('setCustomer', res.data);
    commit('customerLoading', false);
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Customer/Actions.js